import React, { useEffect, useState } from "react";
import { Checkbox, Table } from "antd";
import { COLORS } from "../../layout/theme";
import { TableContainer } from "./styles";
import { get_client_emails_by_clientId } from "../../../api/endpoints/clientEmails";

export default function ClientEmailSelector({
	initialValues,
	onChange,
	clientId,
}) {
	const [clientEmail, setClientEmail] = useState(null);

	const columns = [
		{
			title: "",
			dataIndex: "selected",
			render: (value, record, index) => (
				<Checkbox
					checked={value}
					onChange={(e) => handleChange(record.id, e.target.checked)}
				/>
			),
			width: 35,
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Contacto</div>,
			dataIndex: "name",
			key: "name",
			width: 150,
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Correo</div>,
			dataIndex: "mail",
			key: "mail",
		},
	];

	useEffect(() => {
		const fetch_client_emails = async () => {
			const res = await get_client_emails_by_clientId(clientId);
			setClientEmail(
				res?.clientEmails.map((d) => ({
					...d,
					key: d.id,
					selected: initialValues?.some((a) => a.id === d.id),
				})) || []
			);
		};

		fetch_client_emails();
	}, []);

	useEffect(() => {
		onChange(clientEmail);
	}, [clientEmail]);

	const handleChange = (id, check) => {
		const _pos = clientEmail.map((p) =>
			p.id === id ? { ...p, selected: check } : { ...p }
		);
		setClientEmail(_pos);
	};

	if (!clientEmail || !initialValues) return <div>Loading...</div>;

	return (
		<>
			{!clientEmail ? (
				<div>No hay correosde copia asociados a este cliente</div>
			) : (
				<TableContainer>
					<Table
						scroll={{ y: "300px" }}
						size="small"
						columns={columns}
						dataSource={clientEmail}
						pagination={false}
					/>
				</TableContainer>
			)}
		</>
	);
}
